import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-food-order.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food-tall.png";
import IGQuickPay from "../../../assets/img/Featured/app-qr-quickpay-tall.png";
import DigitalMenu from "../../../assets/img/Featured/digital-menu.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../../components/Header";

const FoodCourtPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page foodCourtPage">
            <Header />
            <div className="page-header">On Site Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Food Court</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Where choice and speed matter most, 
                    Agilysys POS solutions provide diners the 
                    options they need. With convenient self-
                    service ordering and quick payment options. 
                    The result is fast, accurate and on-time food 
                    delivery to keep service moving no matter 
                    the choice.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Food Court", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Food Court", "IG Kiosk");
                    addFlow("IG Kiosk");
                    navigate("/solutions/ig-kiosk")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Kiosk
                    </div>
                    <img src={IGKiosk} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Food Court", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={IGOnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Food Court", "IG Quick Pay");
                    addFlow("IG Quick Pay");
                    navigate("/solutions/ig-quick-pay")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Quick Pay
                    </div>
                    <img src={IGQuickPay} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Food Court", "IG Digital Menu Board");
                    addFlow("IG Digital Menu Board");
                    navigate("/solutions/digital-menu")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Digital Menu Board
                    </div>
                    <img src={DigitalMenu} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default FoodCourtPage;